import { AddBradenScaleReport } from "app/screens/residents/show/AddBradenScaleReport";

export default function AddBradenScaleReportPage() {
  return <AddBradenScaleReport />;
}
